import React from 'react';

// Placeholder component - Wordle game not yet implemented
const Wordle = () => {
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>Wordle Game</h1>
      <p>This game is coming soon!</p>
    </div>
  );
};

export default Wordle;















